import { Stack } from "expo-router"
import { BFColumn } from "@/components/standard/screen/BFColumn"
import { View } from "react-native"

export default () => {
  return (
    <View className={"flex-1 flex-row justify-center"}>
      <BFColumn className={"max-w-[800px]"}>
        <Stack>
          <Stack.Screen
            name="index"
            options={{ headerShown: false, animation: "none" }}
          />
        </Stack>
      </BFColumn>
    </View>
  )
}
